import React from 'react';
import { Box } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import RoleSelector, { LoginRole } from './RoleSelector';
import ThemeToggle from './ThemeToggle';
import FontSizeSelector from './FontSizeSelector';
import LanguageSelector from './LanguageSelector';
import UserAvatar from './UserAvatar';
import { useAuth } from '../../context/AuthContext';
import { useThemeMode } from '../../theme/ThemeModeContext';

/** Application top bar: brand, role switcher, and user/accessibility menu. */
export default function Header() {
  const { role, setRole } = useThemeMode();
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleRoleChange = (nextRole: LoginRole) => {
    setRole(nextRole);
    navigate(nextRole === 'organization' ? '/choose-organization' : '/parent/home');
  };

  return (
    <Box
      component="header"
      sx={(theme) => ({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        px: 5,
        py: 2,
        backgroundColor: theme.app.background,
        borderBottom: `1px solid ${theme.app.borderSubtle}`,
      })}
    >
      <Box component={RouterLink} to="/" sx={{ display: 'block' }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="SchoolCash"
          sx={{ height: 48, width: 'auto', display: 'block' }}
        />
      </Box>

      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <RoleSelector value={role} onChange={handleRoleChange} />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <ThemeToggle />
        <FontSizeSelector />
        <LanguageSelector />
        {user && <UserAvatar firstName={user.firstName} lastName={user.lastName} />}
      </Box>
    </Box>
  );
}
